module.exports = __webpack_public_path__ + "static/assets/c4ceba83cf15016aa9c2cf6c3b9c764b.jpg";